import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import { Folder, Doc, Xls, Ppt, Pdf, Jpg } from '../../../../assets/images';

import {
  WrapperResultItem,
  WrapperBody,
  WrapperHeader,
  WrapperIcon,
  ResultTitleDoc,
  StyledDateFormat
} from './style';

const getIcon = path => {
  const extension = path.substr(-3);
  switch (extension) {
    case 'pdf':
      return Pdf;
    case 'doc':
      return Doc;
    case 'xls':
      return Xls;
    case 'jpg':
      return Jpg;
    case 'ppt':
      return Ppt;
    default:
      return Folder;
  }
};

const DocumentItem = ({
  className,
  title,
  date,
  urlLink,
  onClick,
  icon,
  path
}) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    <WrapperBody>
      <WrapperHeader>
        <WrapperIcon>
          <Icon svg={icon || getIcon(path)} size="m" hover />
        </WrapperIcon>
        <div>
          <ResultTitleDoc>{title}</ResultTitleDoc>
          <StyledDateFormat>{date}</StyledDateFormat>
        </div>
      </WrapperHeader>
    </WrapperBody>
  </WrapperResultItem>
);

DocumentItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node
};

DocumentItem.defaultProps = {
  urlLink: '/'
};

export default DocumentItem;
